import * as http from "../network/TutorHttp";
import Http from "./Http";
import {
  getUserInfo,
  isEmptyOrNull,
  isNotEmptyOrNull,
} from "../utils/common-utils";

export const getDefaultHeaders = async () => {
  let headers = {};
  headers["Content-Type"] = "application/json";
  return headers;
};

let lastTriggeredTimeForSelfLearn = 0;
export const callSelfLearn = async (body) => {
  const currentTime = new Date().getTime();
  if (currentTime - lastTriggeredTimeForSelfLearn < 1000) {
    return;
  }
  lastTriggeredTimeForSelfLearn = currentTime;
  try {
    const res = await Http.post(
      "/schoolai/task/self-learn",
      JSON.stringify(body)
    );
    return res;
  } catch (e) {
    setAnswer("");
    return;
  }
};

export const createGuidedPractice = async (
  topic,
  subTopic,
  gpRandom,
  noOfQuestions,
  userId,
  type = 1
) => {
  // topic = "65b8e4a3b08b23325234eb68";
  let queryParams = `topic_id=${topic}`;
  if (!isEmptyOrNull(subTopic)) {
    queryParams += `&sub_topic_id=${subTopic}`;
  }
  let params = `${queryParams}&criteria=${gpRandom}&question_count=${noOfQuestions}&user_id=${userId}&type=${type}`;
  const endpoint = `/learning-steps/practice-or-learn?${params}`;
  try {
    const res = await Http.get(endpoint);
    if (res?.data?.step_id == 0) {
      return await createGuidedPracticeWithNewjourney(
        topic,
        subTopic,
        gpRandom,
        noOfQuestions,
        userId,
        type
      );
    } else {
      return res;
    }
  } catch (e) {
    return {};
  }
};

export const createGuidedPracticeWithNewjourney = async (
  topic,
  subTopic,
  gpRandom,
  noOfQuestions,
  userId,
  type = 1
) => {
  let queryParams = `topic_id=${topic}`;
  if (!isEmptyOrNull(subTopic)) {
    queryParams += `&sub_topic_id=${subTopic}`;
  }
  let params = `${queryParams}&criteria=${gpRandom}&question_count=${noOfQuestions}&user_id=${userId}&type=${type}&new_journey=true`;
  const endpoint = `/learning-steps/practice-or-learn?${params}`;
  try {
    const res = await Http.get(endpoint);
    return res;
  } catch (e) {
    return {};
  }
};
export const getJourneysByUser = async () => {
  let userInfo = await getUserInfo();
  const endpoint = `/lp-progress?journey_type=guidedPractice&user_id=${userInfo?.userId}&order=-1`;
  try {
    const res = await Http.get(endpoint);
    return res;
  } catch (e) {
    return {};
  }
};

let lastTriggeredTime = 0;
export const learnApiService = async (
  journey_id,
  step_id,
  user_answer,
  count
) => {
  const currentTime = new Date().getTime();
  if (currentTime - lastTriggeredTime < 1000) {
    return;
  }
  lastTriggeredTime = currentTime;
  try {
    let res = "";
    // journey_id = "65e1d009fe19768d3c1be350";
    if (isNotEmptyOrNull(count)) {
      res = await Http.get(
        "/learning-steps/execute-journey?journey_id=" +
          journey_id +
          "&step_id=" +
          step_id +
          "&count=" +
          count +
          "&user_answer=" +
          encodeURIComponent(JSON.stringify(user_answer))
      );
    } else {
      res = await Http.get(
        "/learning-steps/execute-journey?journey_id=" +
          journey_id +
          "&step_id=" +
          step_id
      );
    }
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const saveChatConv = async (body) => {
  try {
    const res = await http.post("/ai-assist/chat-history", body);
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};

export const endTask = async (_id, postId) => {
  const body = {
    taskProgressId: _id,
    taskStatus: "completed",
    postId: postId,
  };
  try {
    const res = await Http.patch(
      "/schoolai/task-progress",
      JSON.stringify(body)
    );
    return res?.data;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const getSubjects = async () => {
  try {
    const res = await Http.post("/schoolai/task/section-subjects");
    return res;
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const getSectionSubjectTree = async () => {
  try {
    const res = await Http.post("/schoolai/task/section-subject-tree");
    return res?.data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const getSectionSubjectTreeV3 = async (payload) => {
  try {
    const res = await Http.post(
      "/schoolai/task/section-subject-tree/v3",
      payload
    );
    return res?.data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const getTaskProgressData = async (
  topicId,
  subTopicId,
  limit = 5,
  offset = 0,
  isChapterEndAssessment,
  isCustomAssessment,
  isPrerequisite
) => {
  try {
    const res = await Http.get(
      `/schoolai/task/get-task-list?topicId=${topicId}&subTopicId=${subTopicId}&limit=${limit}&offset=${offset}&isChapterEndAssessment=${isChapterEndAssessment}&customSubtopicsAssessment=${isCustomAssessment}&isPrerequisite=${isPrerequisite}`
    );
    return res?.data?.data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const getSubjectsForStandalone = async (id) => {
  try {
    const res = await Http.get("/subjects?gradeId=" + id);
    return res.data?.subjects || [];
  } catch (err) {
    console.error(err);
    return [];
  }
};
export const getTopicsForStandalone = async (id) => {
  try {
    //62eb7bf00f58b3a10b440a93
    const res = await Http.get("/topics/v1?subject_id=" + id);
    return res.data || [];
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const postFactualProgress = async (
  factData,
  lp_id,
  basket_id,
  journey_id
) => {
  try {
    let res = await Http.post(
      "/lp-progress/update-data" +
        "/" +
        lp_id +
        "?" +
        "basket_id=" +
        basket_id +
        "&" +
        "journey_id=" +
        journey_id,
      factData
    );

    return res;
  } catch (e) {
    console.log(e);
  }
};

export const getCurriculum = async () => {
  const response = await Http.get(`/master-category/curriculum`);
  return response;
};
export const getGrades = async (id) => {
  const response = await Http.get(`/syllabus/v2/grades/${id}`);
  return response;
};
export const updateProfile = async (inputData) => {
  const response = await Http.patch("/auth/user", JSON.stringify(inputData));
  return response;
};

export const getRandomVinMessage = async (code) => {
  let apiURL = `/message-bank-service/configurations/messages/random`;
  let queryParams = `messagesBankCode=${code}&module=Vin`;
  const response = await Http.get(`${apiURL}?${queryParams}`);
  return response;
};

export const updateChatIdInLpProgress = async (
  journey_id,
  question_id,
  user_answer
) => {
  try {
    let body = { user_answer };
    const res = await Http.patch(
      `/lp-progress/update-journey?journey_id=${journey_id}&question_id=${question_id}`,
      JSON.stringify(body)
    );
    return res?.data;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const getFetchQuestionByID = async (id) => {
  let apiURL = `/question-bank/V1?questionProfile=Tutor&versionUuids=${id}&answerHashtype=2`;
  const response = await Http.get(apiURL);
  return response;
};

export const sendVideoEvents = async (journey_type, body) => {
  try {
    const res = await Http.post(
      `/video-events?journey_type=${journey_type}`,
      JSON.stringify(body)
    );
    return res;
  } catch (e) {
    console.log("Video events data not sent", e);
    return;
  }
};
